import axios from 'axios';
import { apiHost } from './apiHost';

// Ekspor PDF dibuat di browser (jsPDF.save) sehingga server tidak melihatnya. Fungsi ini memasang pencatat pada save() satu kali:
// setiap PDF yang diunduh dicatat di Log Aktivitas (POST /log-aktivitas/ekspor) dengan nama berkas dan format. Gagal mencatat tidak
// pernah mengganggu unduhan.

const alamat = () => {
  const protocol = window.location.protocol === 'https:' ? 'https' : 'http';
  return `${protocol}://${apiHost().replace(/^https?:\/\//, '')}`;
};

/** Kirim satu catatan ekspor ke server (tanpa menunggu, galat diabaikan). */
export const kirimCatatEkspor = (nama, format) => {
  try {
    return Promise.resolve(axios.post(`${alamat()}/log-aktivitas/ekspor`, { nama, format }, { withCredentials: true })).catch(() => null);
  } catch (e) {
    return Promise.resolve(null);
  }
};

/** Bungkus Kelas.prototype.save agar tiap pemanggilan dicatat lewat `kirim(nama, 'pdf')`. Aman dipanggil berulang. */
export const pasangCatatEkspor = (Kelas, kirim = kirimCatatEkspor) => {
  const proto = Kelas && Kelas.prototype;
  if (!proto || typeof proto.save !== 'function' || proto.save.__dicatat) return false;
  const asli = proto.save;
  const baru = function save(nama, ...sisa) {
    try { kirim(String(nama || 'laporan.pdf'), 'pdf'); } catch (e) { /* abaikan */ }
    return asli.call(this, nama, ...sisa);
  };
  baru.__dicatat = true;
  proto.save = baru;
  return true;
};
